import React from 'react';
import './Loader.css';

const Loader = () => (
  <div className="loader-container">
    <div className="spinner"></div>
  </div>
);

export default Loader; 